import React, { FC } from "react";

import {
  convertParentToOptions,
  convertOptionToParent,
  convertParentToOption,
} from "./CommonFunctions";
import { MultiParentsWithMultiChildrenDropdownField } from "./MultiParentsWithMultiChildrenDropdownField";

import {
  ParentType,
  ChildType,
  OptionType,
  DropDownOnChangeType,
} from "~/domains";

import { LabelWithDropDownField } from "~/ui";

type PropsType = {
  selectableDropdownDivisions: ParentType[];
  selectedDropdownDivisions: ParentType[];
  selectableDropdownSections: ChildType[];
  selectedDropdownSections: ChildType[];
  selectableDropdownEmployees?: ParentType[];
  selectedDropdownEmployee?: ParentType;
  onDivisionChange: (value: ParentType[]) => void;
  onSectionChange: (value: ChildType[]) => void;
  onEmployeeChange: (value: ParentType | undefined) => void;
};

export const DivisionAndSectionAndEmployeeDropdownField: FC<PropsType> = ({
  selectableDropdownDivisions,
  selectedDropdownDivisions,
  selectableDropdownSections,
  selectedDropdownSections,
  selectableDropdownEmployees,
  selectedDropdownEmployee,
  onDivisionChange,
  onSectionChange,
  onEmployeeChange,
}: PropsType) => {
  return (
    <>
      <MultiParentsWithMultiChildrenDropdownField
        allParents={selectableDropdownDivisions}
        parentsValue={selectedDropdownDivisions}
        parentLabel="部署"
        parentsOnChange={onDivisionChange}
        allChildren={selectableDropdownSections}
        childrenValue={selectedDropdownSections}
        childLabel="課"
        childrenOnChange={onSectionChange}
      />
      <LabelWithDropDownField
        required={false}
        labelText="ユーザー"
        name="employees"
        options={convertParentToOptions(selectableDropdownEmployees || [])}
        value={
          selectedDropdownEmployee
            ? convertParentToOption(selectedDropdownEmployee)
            : undefined
        }
        onChange={(newValue: DropDownOnChangeType<OptionType>) => {
          onEmployeeChange(
            newValue
              ? convertOptionToParent(newValue as OptionType)
              : undefined,
          );
        }}
      />
    </>
  );
};
